import React, { useState } from 'react';
import { Modal as ModalModule, UI, Utils } from 'common';

import ContactsCommunication from './utils/ContactsCommunication';

const { Modal, ModalButtonActionType } = ModalModule;
const { WrappedInputTextWithLabel } = UI;
const { withLayoutAndModalContexts } = Utils;

const ReferenceNumberModal = ({
	modalId,
	data: { updateContactsState, selectedContacts },
	layoutContext: { isMobile },
	modalContext: { showError, closeModal },
}) => {
	const [clean, setClean] = useState(true);
	const [isReferenceNumberValid, setIsReferenceNumberValid] = useState(true);
	const [referenceNumber, setReferenceNumber] = useState(selectedContacts[0].ReferenceNumber);

	const onFieldChange = e => {
		setReferenceNumber(e.target.value);
		setClean(false);
	};

	const onFieldBlur = () => {
		setIsReferenceNumberValid(referenceNumber.length !== 0);
	};

	const referenceAssociations = async () => {
		const contactIds = selectedContacts.map(contact => contact.ContactId);

		const response = await ContactsCommunication.referenceAssociations({
			contacts: contactIds,
			reference: referenceNumber,
			allSelected: true,
		});

		if (ContactsCommunication.isSuccessful(response)) {
			updateContactsState({ ReferenceNumber: referenceNumber }, true);

			closeModal(modalId, ModalButtonActionType.Ok);
		} else {
			showError({ response });
		}
	};

	const onSaveButtonClick = () => {
		referenceAssociations();
	};

	const primaryButton = {
		type: ModalButtonActionType.Ok,
		text: 'Save',
		onClick: onSaveButtonClick,
		disabled: clean || referenceNumber.length === 0,
		dataqa: 'reference-number-save-button',
	};

	const mobileClassName = isMobile ? 'mobile-wrapper' : '';

	return (
		<Modal
			modalId={modalId}
			className="contacts contacts-reference-modal"
			header="Change Reference #"
			primaryButton={primaryButton}
			size="small"
		>
			<div className="body">
				<WrappedInputTextWithLabel
					showErrorBelow={isMobile}
					isInputInvalid={!isReferenceNumberValid}
					errorMessage="Reference number is required"
					className={`inputtext ${mobileClassName}`}
					label="Reference #:"
					uiElementConfig={{
						type: 'text',
						name: 'referenceNumber',
						value: referenceNumber,
						required: true,
						placeholder: 'Reference Number',
						dataqa: 'referencenumber',
						onChange: onFieldChange,
						onBlur: onFieldBlur,
					}}
				/>
			</div>
		</Modal>
	);
};

export default withLayoutAndModalContexts(ReferenceNumberModal);
